import { Injectable } from '@angular/core';
import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { AlertController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnexionService {
  public deconnexion_subject: Subject<any>;

  private isConnected: boolean = false;
  private loader: any;

  constructor(
    private ble: BLE,
    private loadCtrl: LoadingController,
    private alertCtrl: AlertController,
    private translate: TranslateService
  ) {
    this.deconnexion_subject = new Subject<any>();
  }

  public async bleConnexion(device): Promise<any> {
    console.log('Is Connected BLECONNECT : ', this.isConnected);

    if (this.isConnected == true) {
    }

    /* this.loader = await this.loadCtrl.create({
      message: "Connexion ..."
    })

    this.loader.present();      */

    setTimeout(async () => {
      if (this.isConnected == false) {
        this.displayError();
      }
    }, 10000);

    setTimeout(async () => {
      //  this.loader.dismiss();
    }, 11000);

    return new Promise((resolve, reject) => {
      // this.ble.autoConnect(
      //   device.bleId,
      //   async (res) => {
      //     //  this.loader.dismiss();
      //     this.isConnected = true;
      //     console.log('CONNECT : ', res);

      //     resolve(true);
      //   },
      //   async (error) => {
      //     this.isConnected = false;
      //     console.log('CONNECT ERR : ', error);
      //     //  this.loader.dismiss();
      //     this.deconnexion_subject.next(error);
      //     reject(false);
      //   }
      // );
      this.ble.connect(device.bleId).subscribe(
        async (res) => {
          //  this.loader.dismiss();
          this.isConnected = true;
          console.log('CONNECT : ', res);

          resolve(true);
        },
        async (error) => {
          this.isConnected = false;
          console.log('CONNECT ERR : ', error);
          //  this.loader.dismiss();
          this.deconnexion_subject.next(error);
          reject(false);
        }
      );
    });
  }

  public changeCo() {
    this.isConnected = false;
  }

  async displayError() {
    //  this.loader.dismiss();
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('DEVICEBLE.CONNECTION.ERROR'),
      message: this.translate.instant('DEVICEBLE.CONNECTION.RETRY'),
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            alert.dismiss();
          },
        },
      ],
    });

    await alert.present();
  }
}
/*

checkGps(): Observable<any> {
  return from(this.diagnostic.isLocationEnabled()).pipe(
      map(async (gps) => {
          if (gps) {
              return empty();
          } else {
             this.myError('Tu dois activer le GPS', 'GPS');
          }
      })
  );
}

this.ble.connect(device.bleId).subscribe(async res => {
      this.loader.dismiss();
      this.isConnected = true;
      console.log(res);
      return true;
    }, async error => {
      console.log(error);
      return false;
    });
*/
